import axios from 'axios';
import apisUrls from '../urls';

const getAdminsApi = (paramsFilter) => {
  return axios.get(apisUrls?.getAdmins(paramsFilter));
};

export default getAdminsApi;
